import * as React from 'react'

import { getConfigBySite } from '../../../config/sites'
import createAutoSuggestDataContainer from '../../components/autosuggest/autoSuggestDataContainer'
import createAutoSuggestLogicContainer from '../../components/autosuggest/autoSuggestLogicContainer'
import SearchHeader from '../../components/searchHeader'
import SeoHeadings from '../../components/seoHeadings/seoHeadings'
import AutoSuggest from '../../v0/components/autosuggest/autosuggest'
import CommunitySection from './communitySection'
import FeaturedAuthorSection from './featuredAuthorSection'
import FeaturedItemsSection from './featuredItemsSection'
import FreeItemSection from './freeItemSection'
import MarketingSection from './marketingSection'
import NewestItemSection from './newestItemSection'
import PageSection from './pageSection'
import TutorialsSection from './tutorialsSection'

import * as searchHeaderStyles from '../../components/searchHeader/themes/homepage.module.css'
import * as seoHeadingsStyles from '../../components/seoHeadings/themes/homepage.module.css'
import * as autoSuggestStyles from '../../v0/components/autosuggest/themes/homepage.module.css'
import * as styles from './homePage.module.css'

import { Props } from '../../containers/homePageContainer/createHomePageContainer'

const AutoSuggestContainer = createAutoSuggestDataContainer(
  createAutoSuggestLogicContainer(AutoSuggest)
)

const HomePage = ({
  currentSite,
  isSignedIn,
  metadata,
  categories,
  newestItemsData,
  featuredItems,
  freeItems,
  featuredAuthor,
  fetchNewestItemsByCategory,
  preferences,
  muteVideo,
  reportItemClick,
  makeSearchLink
}: Props) => {
  return (
    <div>
      <div className={styles.searchHeaderSection}>
        <SearchHeader currentSite={currentSite} styles={searchHeaderStyles}>
          {metadata && (
            <SeoHeadings
              TagName="h1"
              heading={metadata.search_area.heading}
              subHeading={metadata.search_area.sub_heading}
              styles={seoHeadingsStyles}
            />
          )}
          <AutoSuggestContainer
            inputName="term"
            value=""
            placeholder={getConfigBySite(
              currentSite,
              'home_search_placeholder'
            )}
            currentSite={currentSite}
            locationParams={{}}
            makeSearchLink={makeSearchLink}
            styles={autoSuggestStyles}
            showCategories={true}
          />
        </SearchHeader>
      </div>

      {metadata && (
        <FeaturedItemsSection
          name="Homepage: Featured items"
          items={featuredItems.slice(0, 10)}
          metadata={metadata.featured_items}
          muteVideo={muteVideo}
          videoMuted={preferences.searchVideoMuted}
          reportItemClick={reportItemClick}
          currentSite={currentSite}
        />
      )}

      {newestItemsData.items && metadata && (
        <PageSection sectionId="newest-item-section">
          <NewestItemSection
            categories={categories}
            name="Homepage: New items"
            currentSite={currentSite}
            fetchNewestItemsByCategory={fetchNewestItemsByCategory}
            metadata={metadata.newest_items}
            newestItemsData={newestItemsData}
            muteVideo={muteVideo}
            videoMuted={preferences.searchVideoMuted}
            reportItemClick={reportItemClick}
            hideCategories={getConfigBySite(currentSite, 'hide_categories')}
            nonSquare={
              !getConfigBySite(currentSite, 'homepage.newest_items_square')
            }
          />
        </PageSection>
      )}

      {metadata && (
        <PageSection sectionId="free-item-section" borderTop>
          <FreeItemSection
            currentSite={currentSite}
            name="Homepage: Free files of the month"
            isSignedIn={isSignedIn}
            items={freeItems}
            metadata={metadata.free_items}
            muteVideo={muteVideo}
            videoMuted={preferences.searchVideoMuted}
            reportItemClick={reportItemClick}
          />
        </PageSection>
      )}

      {metadata && <MarketingSection blocks={metadata.marketing_blocks} />}

      {metadata && (
        <PageSection sectionId="featured-author-section" borderTop>
          <FeaturedAuthorSection
            currentSite={currentSite}
            name="Homepage: Featured authors"
            items={featuredAuthor.matches}
            author={featuredAuthor.author}
            metadata={metadata.featured_author}
            muteVideo={muteVideo}
            videoMuted={preferences.searchVideoMuted}
            reportItemClick={reportItemClick}
          />
        </PageSection>
      )}

      {metadata && <CommunitySection metadata={metadata.community} />}

      {metadata && (
        <PageSection sectionId="tutorial-section">
          <TutorialsSection metadata={metadata.tutorials} />
        </PageSection>
      )}
    </div>
  )
}

export default HomePage
